import { DataBean } from "../DataBean";

export class TimeEventAccounting extends DataBean {



    public async createTimeEventAccountingForProductionOrder(idTimeEvent:any,accountantDate:any,description:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.AccountantDocument_createTimeEventAccountingForProductionOrder_Number_java.util.Date_String_Number", [idTimeEvent,accountantDate,description,idEmployee]);
    }

     public async createTimeEventAccountingForProductionOrdervdos(year:any,month:any,accountantDate:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_createTimeEventAccountingForProductionOrder_Number_Number_java.util.Date_Number", [year,month,accountantDate,idEmployee]);
    }
    
}